module.exports = __webpack_public_path__ + "img/facebook-icon.e9bd31f.svg";